import { render } from "./Switch.vue?vue&type=template&id=329de1b0"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
script.render = render

export default script